const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL ||
    (window.location.hostname === "localhost"
        ? "http://192.168.100.11:8281" // 👈 Local machine
        : "http://10.100.1.31:8281");   // 👈 Docker network (service name)

const config = {
    // Base API Configuration
    API_BASE_URL,
    STANBIC_API_PREFIX: '/stanbic/api',
    STANCHART_API_PREFIX: '/stanchart/api',
    ADMIN_API_PREFIX: '/admin/api',
    ADMIN_API_VERSION: 'v1',
    STANBIC_API_VERSION: 'v1',
    STANCHART_API_VERSION: 'v1',
    NIRA_API_PREFIX: '/nira/api',
    NIRA_API_VERSION: 'v1',
    NOTIFICATIONS_API_PREFIX: '/notifications/api',
    NOTIFICATIONS_API_VERSION: 'v1',

    // Full API endpoint base (constructed)
    get API_BASE_ENDPOINT() {
        return `${this.API_BASE_URL}${this.ADMIN_API_PREFIX}/${this.ADMIN_API_VERSION}`;
    },

    get NIRA_API_BASE_ENDPOINT() {
        return `${this.API_BASE_URL}${this.NIRA_API_PREFIX}/${this.NIRA_API_VERSION}`;
    },

    // Auth endpoints
    AUTH_ENDPOINTS: {
        LOGIN: '/auth/login',
        LOGOUT: '/auth/login/logout',
        REGISTER: '/auth/signup',
        INITIATE_RESET_PASSWORD: '/auth/reset-password/initiate',
        RESET_PASSWORD: '/auth/reset-password',
        VERIFY_ACCESS_TOKEN: '/auth/verify-access-token',
        REFRESH_TOKEN: '/auth/refresh-token',
        CHECK_TOKEN_VALIDITY: '/auth/check-token-validity',
    },

    // OAUTH Clients
    OAUTH_CLIENT: {
        ENDPOINTS: {
            REGISTER_CLIENT: '/auth-client',
            DELETE_CLIENT: '/auth-client/delete',
            GET_CLIENTS: '/auth-client',
            REGENERATE_CREDENTIALS: '/auth-client/regenerate-credentials',
        },
    },

    // User endpoints
    SIGNUP_ENDPOINTS: {
        REQUEST_ACCESS: '/auth/signup',
    },

    USER_ENDPOINTS: {
        PROFILE: '/user',
    },

    SERVICE_ENDPOINTS: {
        SYSTEM_STATUS: '/system/status',
    },

    // Timeout settings
    TIMEOUTS: {
        API_REQUEST: 300000,
        TOKEN_REFRESH: 300000,
    },

    // Stanbic endpoints
    STANBIC: {
        ENDPOINTS: {
            CONFIGURATIONS: '/config',
            GENERATE_SSH_KEY: '/config/generate-ssh-keys',
            GENERATE_PGP_KEY: '/config/generate-pgp-keys',
            TEST_CONNECTION: '/config/test',
            GET_DEFAULT_CONFIG: '/config/get-default',
            GET_BATCH_PAYMENTS: '/s2b/get-batches',
            GET_TRANSACTIONS: '/s2b/breakdown',
            GET_AUDIT_TRAILS: '/logs',
        },
    },

    // StanChart endpoints
    STANCHART: {
        ENDPOINTS: {
            CONFIGURATIONS: '/config',
            ACTIVATE: '/config/activate',
            TEST_CONNECTION: '/config/test',
            GET_DEFAULT_CONFIG: '/config/get-default',
            GET_BATCH_PAYMENTS: '/s2b',
            GET_TRANSACTIONS: '/s2b/breakdown',
            GET_AUDIT_TRAILS: '/logs',
        },
    },

    // Nira endpoints
    NIRA_ADMIN_ENDPOINTS: {
        RESET_NIRA_PASSWORD: "/admin/reset-password",
        CREATE_CONFIG: "/admin/create-config",
        FETCH_CONFIG: "/admin/load",
        FETCH_VERIFICATION_REQUESTS: "/admin/verification-requests",
        FETCH_VERIFICATION_REQUEST: "/admin/getVerificationRequest",
        GET_AUDIT_TRAILS: "/logs",

        GET_COUNTS_BY_STATUS: '/admin/counts-by-status',
        GET_TRENDS_BY_MONTH: '/admin/trends-by-month',
        GET_VERIFICATIONS_TODAY: '/admin/verifications-today',
    },

    NIRA_VERIFY_IDENTITY: {
        VERIFY_PERSONS: '/verify-person',
        RUN_ALL_TESTS: '/run-all-tests',
    },

    // Pagination defaults
    PAGINATION: {
        DEFAULT_PAGE: 1,
        DEFAULT_LIMIT: 10,
    },

    // Notifications endpoints
    NOTIFICATIONS: {
        ENDPOINTS: {
            SMTP: {
                SAVE: '/smtp',
                UPDATE: '/smtp',
                DELETE: '/smtp/delete',
                GET_LIST: '/smtp',
                GET_BY_ID: '/smtp/get-by-id'
            },
            TEMPLATES: {
                SAVE: '/notification-templates',
                UPDATE: '/notification-templates',
                DELETE: '/notification-templates/delete',
                GET_LIST: '/notification-templates/get-list',
                GET_BY_ID: '/notification-templates/get-by-id',
                GET_NOTIFICATION_TYPES: '/notification-templates/get-notification-types',
                GET_NOTIFICATION_TEMPLATE_APPLICATIONS: '/notification-templates/get-notification-template-apps',
                GET_NOTIFICATION_CATEGORIES: '/notification-templates/get-notification-categories',
                GET_NOTIFICATION_PLATFORMS: '/notification-templates/get-notification-platforms',
                GET_RESERVED_WORDS: '/notification-templates/get-reserved-words',

            },
        }
    },
};

export default config;